// obtain plugin
var cc = initCookieConsent();

// run plugin with your configuration
cc.run({
    current_lang: 'cs',
    autoclear_cookies: true,                   // default: false
    theme_css: '/assets/js/libs/cookieconsent/cookieconsent.css',
    page_scripts: true,                        // default: false

    // delay: 0,                               // default: 0
    // auto_language: null                     // default: null; could also be 'browser' or 'document'
    // autorun: true,                          // default: true
    // force_consent: false,                   // default: false
    // hide_from_bots: false,                  // default: false
    // remove_cookie_tables: false             // default: false
    // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
    // cookie_expiration: 182,                 // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: '/',                       // default: root
    // cookie_same_site: 'Lax',                // default: 'Lax'
    // use_rfc_cookie: false,                  // default: false
    // revision: 0,                            // default: 0

    onFirstAction: function(user_preferences, cookie){
        // callback triggered only once
    },

    onAccept: function (cookie) {
        // ...
    },

    onChange: function (cookie, changed_preferences) {
        // ...
    },

    languages: {
        'cs': {
            consent_modal: {
                title: 'Používáme cookies!',
                description: 'Dobrý den, tato stránka používá cookies pro své fungování a k analýze návštěvnosti.',
                primary_btn: {
                    text: 'Přijmout vše',
                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Nastavení cookies',
                    role: 'c-settings'        // 'settings' or 'accept_necessary'
                }
            },
            settings_modal: {
                title: 'Nastavení cookies',
                save_settings_btn: 'Uložit nastavení',
                accept_all_btn: 'Přijmout vše',
                reject_all_btn: 'Odmítnout vše',
                close_btn_label: 'Zavřít',
                cookie_table_headers: [
                    {col1: 'Název'},
                    {col2: 'Doména'},
                    {col3: 'Expirace'},
                    {col4: 'Popis'}
                ],
                blocks: [
                    {
                        title: 'Přehled používaných cookies 📢',
                        description: 'Dobrý den, tato stránka používá cookies pro své fungování a k analýze návštěvnosti. Pro více informací si přečtěte <a href="https://policies.google.com/technologies/cookies?hl=cs" class="no-visited" target="_blank" rel="noopener">dokument o&nbsp;zpracování informací</a>.'
                    }, {
                        title: 'Nezbytné (funkční) cookies',
                        description: 'Tyto cookies jsou nezbytné pro řádné fungování webu.',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                        },
                        cookie_table: [
                            
                            {
                                col1: 'PHPSESSID',
                                col2: 'vasfotokoutek.cz',
                                col3: '2 týdny',
                                col4: 'Cookie nutná pro chod webu. Ukládá informaci o Vaší aktuální relaci (pro přihlášení).',
                            },
                            {
                                col1: 'nette-samesite',
                                col2: 'vasfotokoutek.cz',
                                col3: 'Po dobu návštěvy',
                                col4: 'Cookie nutná pro vyšší bezpečnost webu.',
                            },
                            {
                                col1: 'ssupp.vid',
                                col2: 'vasefotobudka.cz',
                                col3: '6 měsíců',
                                col4: 'Cookie pro SmartSupp pro uchování ID návštěvníka. Hlavním účelem této cookie je identifikace návštěvníků Vašich webových stránek. Na základě toho můžeme při opětovném načtení stránky spárovat návštěvníka s konverzaci. Díky tomu probíhající konverzace nezmizí ani po opětovném načtení stránky, tudíž návštěvníci mohou pokračovat tam, kde skončili. \nTato cookie nám tedy umožňuje zobrazit zdroj, informace o prohlížeči a počet návštěv, které jsou uvedeny v informacích o návštěvníkovi v Dashboard.',
                            }
                        ]
                    }, {
                        title: 'Analytické a výkonostní cookies',
                        description: 'Tyto cookies nám umožňují měřit návštěvnost na webu.',
                        toggle: {
                            value: 'analytics',     // your cookie category
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [             // list of all expected cookies
                            {
                                col1: '^_ga',       // match all cookies starting with "_ga"
                                col2: '.vasfotokoutek.cz',
                                col3: '2 roky',
                                col4: 'Slouží pro měření návštěvnosti pomocí Google Analytics.',
                                is_regex: true
                            },
                            {
                                col1: '_gid',
                                col2: '.vasfotokoutek.cz',
                                col3: '1 den',
                                col4: 'Cookie pro Google Analytics. Slouží pro měření návštěvy a výkonu webu.',
                            },
                            {
                                col1: '^_gat',
                                col2: '.vasfotokoutek.cz',
                                col3: '1 minuta',
                                col4: 'Cookie pro Google Tag Manager. Slouží pro rozlišení uživatelů.',
                            }
                        ]
                    }, 
                    {
                        title: 'Marketingové cookies',
                        description: 'Tyto cookies slouží pro marketingové účely.',
                        toggle: {
                            value: 'marketing',
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: [             // list of all expected cookies
                            {
                                col1: '_fbp',
                                col2: '.vasfotokoutek.cz',
                                col3: '3 měsíce',
                                col4: 'Cookie pro Facebook. Slouží pro zobrazování relevantních reklam po návštěvě tohoto webu.',
                            },
                            {
                                col1: 'fr',
                                col2: '.facebook.com',
                                col3: '3 měsíce',
                                col4: 'Cookie pro Facebook (Facebook pixel / Facebook social plugin). Slouží pro zobrazování relevantních reklam po návštěvě tohoto webu.',
                            },
                            {
                                col1: 'sid',
                                col2: '.seznam.cz',
                                col3: '1 měsíc',
                                col4: 'Cookie s digitálně podepsaným a zašifrovaným ID a posledním přihlášením uživatele.',
                            },
                            {
                                col1: 'ssupp.visits',
                                col2: 'vasefotobudka.cz',
                                col3: '6 měsíců',
                                col4: 'Cookie pro SmartSupp pro uchování předchozího počtu návštěv. Na základě toho následně dokážeme přesněji zacílit automatické zprávy a chatboty.',
                            }
                        ]
                    }, 
                    // {
                    //     title: 'Personalizační cookies',
                    //     description: 'Tyto cookies sbírají informace o tom, co na e-shopu děláte a umožňují Vám doručit obsah na míru.',
                    //     toggle: {
                    //         value: 'targeting',
                    //         enabled: false,
                    //         readonly: false
                    //     }
                    // }, 
                    {
                        title: 'Více informací',
                        description: 'V případě jakýchkoliv dotazů nás můžete <a class="cc-link" href="/kontakt">kontaktovat</a>.',
                    }
                ]
            }
        }
    }
});